/* eslint-disable no-unused-vars */
import React, { lazy } from 'react'
import { Redirect } from 'react-router-dom'
import AdminLayout from '../layouts/AdminLayout'
import GuestGuard from '../components/Auth/GuestGuard'
import AuthGuard from '../components/Auth/AuthGuard'
import { BASE_URL } from '../config/constant'
import { cash_routes } from './cash-route'
import { treasury_routes } from './treasury-route'
import { administration_routes } from './administration-route'
import { user_routes } from './user-route'
import { documents_routes } from './document-route'
import { routeBackOffice } from './back-office-route'
import { risk_routes } from './risk-route'

export const routes = [
  {
    exact: true,
    guard: GuestGuard,
    path: '/auth/signin',
    component: lazy(() => import('../views/auth/signin/SignIn2')),
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/auth/oidc',
    component: lazy(() => import('../views/auth/signin/SignIn2')),
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/bo/auth/oidc',
    component: lazy(() => import('../views/back-office/auth/RedirectOpenIdBo')),
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/auth/okta',
    component: lazy(() => import('../views/auth/signin/SignIn2')),
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/login/callback',
    component: lazy(() => import('../views/auth/signin/SignIn2')),
  },
  {
    exact: true,
    guard: AuthGuard,
    path: '/sconnect',
    component: lazy(() =>
      import('../views/menu/cash/flux/signature-pad/SconnectWindow')
    ),
  },
  {
    exact: true,
    path: '/404',
    component: lazy(() => import('../views/errors/NotFound404')),
  },
  {
    exact: true,
    path: '/maintenance/coming-soon',
    component: lazy(() => import('../views/maintenance/ComingSoon')),
  },
  {
    exact: true,
    path: '/maintenance/error',
    component: lazy(() => import('../views/maintenance/Error')),
  },
  {
    exact: true,
    path: '/maintenance/offline-ui',
    component: lazy(() => import('../views/maintenance/OfflineUI')),
  },
  {
    exact: true,
    path: '/auth/signin-2',
    component: lazy(() => import('../views/auth/signin/SignIn2')),
  },
  {
    exact: true,
    path: '/tracking/:id',
    component: lazy(() => import('../views/gpi-tracker/tracker')),
  },

  {
    exact: true,
    path: '/auth/reset-password',
    component: lazy(() =>
      import('../views/auth/reset-password/ResetPassword2')
    ),
  },
  {
    exact: true,
    path: '/auth/resetpassword/checklink',
    component: lazy(() => import('../views/auth/checklink/UpdatePassword')),
  },
  {
    exact: true,
    path: '/auth/change-password',
    component: lazy(() => import('../views/auth/ChangePassword')),
  },
  {
    exact: true,
    path: '/bo/auth/signin',
    component: lazy(() => import('../views/back-office/auth/Signin')),
  },
  {
    path: '*',
    layout: AdminLayout,
    guard: AuthGuard,
    routes: [
      ...cash_routes,
      ...treasury_routes,
      ...administration_routes,
      ...user_routes,
      ...documents_routes,
      ...routeBackOffice,
      ...risk_routes,
      {
        exact: true,
        path: '/dashboard',
        component: lazy(() => import('../views/dashboard/index')),
      },
      {
        path: '*',
        exact: true,
        component: () => <Redirect to={`${BASE_URL}/dashboard`} />,
      },
    ],
  },
]

